<template>
  <!-- 组合商品 -->
  <div class="product-groups">
    <!--  -->
    <div v-if="theme !== 'athena' && group_product_style == 'default'" class="grouped_products_default">
      <h3 class="title_font2" style="text-align: left; font-size: 17px; font-weight: 600">
        {{ group_products_title }}
        <span class="grouped_products_card__title__discounts d-block" v-if="discounts_tips">{{
          discounts_tips.onOff ? discounts_tips.tips_success : discounts_tips.tips_fail
        }}</span>
      </h3>
      <div
        class="product-groups-info clearfix"
        :style="group_products_position != 'below' && group_products_position != 'foot' ? 'width: 100%;' : ''"
      >
        <div
          class="groups-img"
          :style="{
            display: group_products_position != 'below' && group_products_position != 'foot' ? 'flex' : '',
            flexWrap: 'wrap',
          }"
        >
          <template v-for="(item, index) in featureImageId">
            <div
              class="product-groups-img"
              :key="index"
              :style="{
                width: index != 0 && index != 3 ? 'calc((100% - 43px)/ 3 + 21.5px)' : 'calc((100% - 43px)/ 3 )',
                margin: '8px 0 !important',
              }"
              :class="
                (group_products_position != 'below' && group_products_position != 'foot') || isMobile()
                  ? ''
                  : 'product-groups-blow'
              "
            >
              <div
                class="dot"
                :style="{
                  margin: group_products_position != 'below' && group_products_position != 'foot' ? 'auto' : 'auto 0px',
                  width: '25.5px',
                }"
                v-if="
                  (group_products_position != 'below' && group_products_position != 'foot') || isMobile()
                    ? index != 0 && index != 3
                    : index != 0
                "
              >
                +
              </div>
              <a :href="'/products/' + item.post_name" style="position: relative; width: 100%">
                <!-- <img :src="item.img" :alt="item.img" width="30%" /> -->
                <v-img-card :data_src="item.thumbnail" :data_url="item.url" img_type="cover"></v-img-card>
                <div
                  class="modulesOverlay"
                  style="border-radius: 4px"
                  v-if="checkedProduct.indexOf(item.id) == -1"
                ></div>
              </a>
            </div>
            <!-- <div class="product-groups-link" v-if="index!=featureImageId.length-1">+</div> -->
          </template>
        </div>
      </div>

      <div
        class="product-groups-total"
        :style="{
          marginLeft: group_products_position != 'below' && group_products_position != 'foot' ? '' : '0px',
          width:
            (group_products_position != 'below' && group_products_position != 'foot') || isMobile()
              ? '100%'
              : 'max-content',
          textAlign: isMobile() ? 'center' : '',
        }"
        v-if="group_products_position!='button_above'"
        >
        <div v-if="checkedProduct.length>0" class="commoditypricetype" style="padding:10px 0;">
          <span class="page_text_font">{{$t('combined.total_price')}}：</span>
          <v-selectprice
            :font-size="14"
            :regular-font-size="14"
            :disable_select="true"
            :currency_style="currency_style"
            :country="theme == 'showtime' ? (!show_currency_selector ? '' : $store.state.pricetype) : ''"
            :price="priceTotal.priceSum"
            :regular_price_num="priceTotal.regularPriceSum > priceTotal.priceSum ? priceTotal.regularPriceSum : ''"
            fontSize="14"
          ></v-selectprice>
          <div v-if="discounts_tips && discounts_tips.onOff" style="font-size: 13px;color:#666">
            {{ discounts_tips.price_tips_success }}
          </div>
        </div>
        <div
          class="product-groups-tips page_text_font"
          :class="
            (group_products_position != 'below' && group_products_position != 'foot') || isMobile()
              ? ''
              : 'dafeult_below'
          "
          v-if="checkedProduct.length === 0 && !all_stock"
        >
          {{ $t('combined.select_one') }}
        </div>
        <div
          class="product-groups-tips page_text_font"
          :class="
            (group_products_position != 'below' && group_products_position != 'foot') || isMobile()
              ? ''
              : 'dafeult_below'
          "
          v-if="all_stock"
        >
          {{ $t('detail.sold_out') }}
        </div>
        <el-button
          class="gocart secondary_title product-groups-total__gocart"
          :class="checkedProduct.length === 0 ? 'soldout' : 'gocart'"
          style="margin-bottom: 16px; height: 50px"
          type="button"
          native-type="submit"
          :loading="loading"
          :disabled="checkedProduct.length === 0"
          @click="addcart"
          :style="{
            color: group_product_all.text_color,
            background: group_product_all.background_color,
          }"
          >
            <i class="iconfont icon-gouwuche" />
            {{ group_product_all.button_text }}
          </el-button
        >
      </div>

      <div
        class="product-groups-info product-groups-list row"
        style="margin-left: 0; width: 100%"
        :style="theme == 'venue' ? 'margin-left:0px' : ''"
      >
        <el-checkbox-group
          style="width: 100%"
          text-color="#000000"
          fill="#000000"
          v-model="checkedProduct"
          @change="handleCheckedCitiesChange"
        >
          <!-- 主商品 -->

          <el-checkbox
            class="clearfix item_checkbox"
            :class="[isMobile() ? 'phone_checkbox' : '', inFontFamilyList ? 'font_family_checkbox' : '']"
            style="display: block; line-height: 30px; margin-right: 0"
            :style="{ opacity: checkedProduct.indexOf(product.ID) !== -1 }"
            :label="product.ID"
            :key="product.ID"
            :disabled="!sub_stock[`product_${product.ID}`]"
            :checked="sub_stock[`product_${product.ID}`]"
            v-if="post_status[`product_${product.ID}`] && group_products_position !== 'button_above'"
          >
            <!-- {{product.post_title}} -->
            <a class="toSub page_text_font" :href="'/products/' + product.post_name">{{ product.post_title }}</a>
            <!-- <br v-if="group_products_position!='below'&&group_products_position!='foot'" /> -->

            <v-selectprice
              class="selectprice"
              :class="{ 'd-block':group_products_position == 'below' || group_products_position =='foot' }"
              :font-size="14"
              :regular-font-size="14"
              :disable_select="true"
              :currency_style="currency_style"
              :country="theme == 'showtime' ? (!show_currency_selector ? '' : $store.state.pricetype) : ''"
              style="margin: 0 3px"
              :price="price[`product_${product.ID}`]"
              fontSize="14"
              :regular_price_num="
                regular_price[`product_${product.ID}`] > price[`product_${product.ID}`]
                  ? regular_price[`product_${product.ID}`]
                  : ''
              "
            ></v-selectprice>
            <div class="groups-select" :style="{float:narrowerscreen?'':'right'}">
              <div class="itemProduct__num" :style="{'margin-right': product.variants && product.variants.length > 1? '14px':'','vertical-align':product.variants && product.variants.length > 1? 'top':'unset'}">
                <span>Quantity</span>
                <v-inputnum mode="notBoder" v-model="num[`product_${product.ID}`]" :min="1" :step="1"></v-inputnum>
              </div>
              <div class="d-inline-block" style="position: relative"  v-if="product.variants && product.variants.length > 1">
                <select
                  class="secondary_title product-groups-select"
                  v-model="variant[`product_${product.ID}`]"
                  @change="changevariant(product.variants, product.ID, product)"
                  :name="variant[`product_${product.ID}`]"
                >
                  <option v-for="subitem in product.variants" :key="subitem.ID" :value="subitem.ID">
                    <span v-for="(option, optionindex) in subitem.attrs" :key="subitem.ID + optionindex + option.value">
                      {{ optionindex == subitem.attrs.length - 1 ? option.value : option.value + ' / ' }}
                    </span>
                  </option>
                </select>
                <svg
                  style="
                    width: 12px;
                    position: absolute;
                    right: 10px;
                    top: 55%;
                    color: #999;
                    transform: translateY(-50%);
                  "
                  class="Icon Icon--select-arrow"
                  role="presentation"
                  viewBox="0 0 19 12"
                >
                  <polyline
                    fill="none"
                    stroke="currentColor"
                    points="17 2 9.5 10 2 2"
                    fill-rule="evenodd"
                    stroke-width="2"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </div>
            <!-- <br
              v-if="(group_products_position!='below'&&group_products_position!='foot')&&product.variants&&product.variants.length>1"
            />-->
          </el-checkbox>
          <!-- sub_products -->
          <template v-for="item in group_product">
            <el-checkbox
              class="clearfix item_checkbox"
              :class="[isMobile() ? 'phone_checkbox' : '', inFontFamilyList ? 'font_family_checkbox' : '']"
              style="display: block; line-height: 30px; margin-right: 0"
              :style="{ opacity: checkedProduct.indexOf(item.ID) !== -1 }"
              :label="item.ID"
              :key="item.ID"
              :disabled="!sub_stock[`product_${item.ID}`]"
              :checked="sub_stock[`product_${item.ID}`]"
              v-if="post_status[`product_${item.ID}`]"
            >
              <a class="toSub page_text_font" :href="'/products/' + item.post_name">{{ item.post_title }}</a>
              <!-- <br v-if="group_products_position!='below'&&group_products_position!='foot'" /> -->

              <v-selectprice
                class="selectprice"
                :class="{ 'd-block':group_products_position == 'below' || group_products_position =='foot' }"
                :font-size="14"
                :regular-font-size="14"
                :disable_select="true"
                :currency_style="currency_style"
                :country="theme == 'showtime' ? (!show_currency_selector ? '' : $store.state.pricetype) : ''"
                style="margin: 0 3px"
                :price="price[`product_${item.ID}`]"
                fontSize="14"
                :regular_price_num="
                  regular_price[`product_${item.ID}`] > price[`product_${item.ID}`]
                    ? regular_price[`product_${item.ID}`]
                    : ''
                "
              ></v-selectprice>
              <div  class="groups-select" :style="{float:narrowerscreen?'':'right'}">
                <div class="itemProduct__num" :style="{'margin-right': item.variants && item.variants.length > 1? '14px':'','vertical-align':item.variants && item.variants.length > 1? 'top':'unset'}">
                  <span>Quantity</span>
                  <v-inputnum mode="notBoder" v-model="num[`product_${item.ID}`]" :min="1" :step="1"></v-inputnum>
                </div>
                <div class="d-inline-block" style="position: relative" v-if="item.variants && item.variants.length > 1">
                  <select
                    v-model="variant[`product_${item.ID}`]"
                    @change="changevariant(item.variants, item.ID, item)"
                    :name="variant[`product_${item.ID}`]"
                    class="secondary_title product-groups-select"
                  >
                    <option v-for="subitem in item.variants" :key="subitem.ID" :value="subitem.ID">
                      <span
                        v-for="(option, optionindex) in subitem.attrs"
                        :key="subitem.ID + optionindex + option.value"
                      >
                        {{ optionindex == subitem.attrs.length - 1 ? option.value : option.value + ' / ' }}
                      </span>
                    </option>
                  </select>
                  <svg
                    style="
                      pointer-events: none;
                      width: 12px;
                      position: absolute;
                      right: 10px;
                      top: 55%;
                      color: #999;
                      transform: translateY(-50%);
                    "
                    class="Icon Icon--select-arrow"
                    role="presentation"
                    viewBox="0 0 19 12"
                  >
                    <polyline
                      fill="none"
                      stroke="currentColor"
                      points="17 2 9.5 10 2 2"
                      fill-rule="evenodd"
                      stroke-width="2"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
              </div>

              <!-- <br
                v-if="(group_products_position!='below'&&group_products_position!='foot')&&item.variants&&item.variants.length>1"
              />-->
            </el-checkbox>
          </template>
        </el-checkbox-group>
      </div>
    </div>
    <!-- 卡片式组合商品 -->
    <v-grouped-card
      v-if="group_product_style == 'card'"
      :group_products_title='group_products_title'
      :checkedProduct='checkedProduct'
      :product='product'
      :group_product='group_product'
      :group_products_position='group_products_position'
      :sub_stock='sub_stock'
      :featureImageId='featureImageId'
      :changevariant='changevariant'
      :variant='variant'
      :currency_style='currency_style'
      :show_currency_selector='show_currency_selector'
      :priceTotal='priceTotal'
      :loading='loading'
      :addcart='addcart'
      :group_product_all='group_product_all'
      :theme='theme'
      :num="num"
      :price='price'
      :all_stock='all_stock'
      :discounts_tips="discounts_tips"
      :narrowerscreen="narrowerscreen"
      @updatecheckedProduct='updatecheckedProduct'></v-grouped-card>

     <!-- 主商品和组合商品总价  -->
     <div class="grouped-product-bottom" v-if="group_products_position === 'button_above'">
       <div class="gpab-price">
        <div class="gpab-price-icon">
          {{ $t("combined.total_price") }}:
        </div>
         <div class="gpab-price-num">
           <v-simplePrice
             :price="priceTotal.priceSum + Number(now_variant_computed_price.price) || 0"
             :style="{ marginLeft: '10px' }"
           ></v-simplePrice>
           <v-simplePrice
             mode="regular_price"
             v-if="
               (priceTotal.priceSum + Number(now_variant_computed_price.price) || 0) <
               (priceTotal.regularPriceSum + Number(now_variant_computed_price.regular_price) ||
                 0)
             "
             :price="
               priceTotal.regularPriceSum + Number(now_variant_computed_price.regular_price) ||
               0
             "
           ></v-simplePrice>
         </div>
       </div>
     </div>

  </div>
</template>
<script>
import googleAnalysis from '@/js/lib/ga'
import vGroupedCard from './groupedproductCard.vue'
import vImgCard from '@/js/components/common/imgCard.vue';
import vInputnum from "@/views/venue/js/common/inputnum.vue";
export default {
  props: [
    "group_product",
    "group_product_all",
    "stock",
    "getSymbolFromCurrency",
    "smallimg",
    "product",
    "cart_type",
    "group_products_title",
    "group_products_position",
    "show_currency_selector",
    "theme",
    "currency_style",
    "group_product_style",
    "now_variant_computed_price", //主商品价格
    'group_product_price_rules',
    'narrowerscreen',
  ],
  data() {
    return {
      variant: {},
      featureImageId: [],
      variantId: {},
      price: {},
      num: {},
      regular_price: {},
      loading: false,
      sub_stock: {},
      post_status: {},
      checkedProduct: [],
      title: {},
      categories: {},
      all_stock: false,
      inFontFamilyList: false,
    }
  },
  methods: {
    //判断是否为移动端
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    //由卡片组件传回的checkedProduct数据
    updatecheckedProduct(val) {
      this.checkedProduct = val
    },

    handleCheckedCitiesChange(value) {
      this.checkedProduct = value
    },
    reload() {
      this.$forceUpdate()
    },
    changevariant(variantAll, id, all) {
      variantAll.forEach((list) => {
        if (list.ID == this.variant[`product_${id}`]) {
          // this.sub_stock[`product_${id}`] = list.buy_able;
          if (list.buy_able) {
            this.sub_stock[`product_${id}`] = true
            this.checkedProduct = Array.from(new Set(this.checkedProduct).add(id))
            // this.tip_soldout = false;
          } else {
            this.sub_stock[`product_${id}`] = false
            // this.tip_soldout = true;
            this.checkedProduct.forEach((item, index) => {
              if (item == id) {
                this.checkedProduct.splice(index, 1)
              }
            })
          }
          this.featureImageId.forEach((imgItem) => {
            if (imgItem.id == id) {
              imgItem.img =
                (list.feature_image && list.feature_image.thumbnail) ||
                (all.feature_image && all.feature_image.thumbnail)
              imgItem.url =
                (list.feature_image && list.feature_image.url) ||
                (all.feature_image && all.feature_image.url)
            }
          })
          this.variantId[`product_${id}`] = list.ID
          this.variant[`product_${id}`] = list.ID
          this.price[`product_${id}`] = Number(list.price)
          //this.$set(this.price,`product_${id}`,Number(list.price))
          this.regular_price[`product_${id}`] = Number(list.regular_price)
        }
      })

      if (Object.keys(this.sub_stock).every((item) => this.sub_stock[item] == false)) {
        this.all_stock = true
      } else {
        this.all_stock = false
      }
      this.reload()
    },
    async addcart() {
      let arr = []
      this.checkedProduct.forEach((item) => {
        let addproduct = { quantity: this.num[`product_${item}`] }
        addproduct.product_id = item
        if (this.variantId[`product_${item}`] !== item) {
          addproduct.variant_id = this.variantId[`product_${item}`]
        }
        arr.push(addproduct)
      })
      let obj = { product: arr }
      try {
        this.loading = true
        let res = await this.$axios.post(API.batchCart, obj)
        if (window.fbq) {
          arr.forEach((item) => {
            window.fbq('track', 'AddToCart', {
              content_type: 'product_group',
              content_ids: [item.product_id],
              value: this.price[`product_${item.product_id}`],
              num_items: 1,
              content_name: this.title[`product_${item.product_id}`],
              currency: res.data.currency,
              content_category: this.categories[`product_${item.product_id}`],
            })
          })
        }
        if (window._learnq) {
          obj.product.forEach((item) => {
            this.group_product.forEach((items) => {
              if (item.product_id == items.ID) {
                this.klaviyo_addtocart(items, item)
              }
            })
          })
        }
        if (window.snaptr) {
          let itemIds = []
          for (let item of arr) {
            itemIds.push(item.product_id)
          }
          window.snaptr('track', 'ADD_CART', {
            currency: res.data.currency,
            item_category: null,
            item_ids: itemIds,
            number_items: arr.length,
            price: this.priceTotal.priceSum,
          })
        }

        // if (window.gtag) {
        //   window.gtag("event", "add_to_cart");
        // }
        // 添加到购物车
        googleAnalysis.event(googleAnalysis.gaAction.add)

        this.$store.dispatch('change_news_cart', res.data)
        this.$store.dispatch('cartContentsCount', res.data.cart_contents_count)
        localStorage.setItem('cartContentsCount', res.data.cart_contents_count)
        if(res.data){
          this.$store.commit("change_button_disabled", true);
        }
        if ((this.theme == 'Brooklyn' || this.theme == 'showtime') && this.cart_type == 'drawer') {
          this.loading = false
          if (this.theme == 'Brooklyn') {
            this.$store.dispatch('change_cart_type', true)
            this.$store.commit("change_button_disabled", false);
          }
          if (this.theme == 'showtime') {
            document.body.scrollTop = document.documentElement.scrollTop = 0
            this.$('#collapseExample').collapse('show')
          }
        } else if ((this.theme == 'venue' || this.theme == 'showtime') && this.cart_type == 'popup') {
          this.loading = false
          this.$store.dispatch('change_button_disabled', false)
          this.$('#modalCart').modal('show')
        } else if (this.theme == 'vogue' && (this.cart_type == 'drawer' || this.cart_type == 'popup')) {
          this.loading = false
          this.showInlineCart()
        } else {
          if(this.theme !== 'Brooklyn'){
            window.open('/cart', '_self')
            setTimeout(() => {
              this.loading = false
            }, 5000)
          }
        }
        setTimeout(() => {
          this.loading = false
          this.$store.commit("change_button_disabled", false);
        }, 800)
      } catch (error) {
        this.loading = false
        this.$store.commit("change_button_disabled", false);
        if (error?.response?.data?.errors) {
          this.$message.error(Object.values(error.response.data.errors)[0][0])
        } else if (error?.response?.data?.message) {
          this.$message.error(error.response.data.message)
        }
      }
    },
  },
  beforeMount() {
    // variant_attrs featureImageId 数据结构初始化
    this.title[`product_${this.product.ID}`] = this.product.post_title
    this.post_status[`product_${this.product.ID}`] = this.product.post_status == 'publish'
    let mainCategories = []
    if (this.product.categories && this.product.categories.length > 0) {
      this.product.categories.forEach((item) => {
        mainCategories.push(item.name)
      })
    }
    this.categories[`product_${this.product.ID}`] = mainCategories;
    if(this.group_products_position !== 'button_above'){
    if (this.product.variants.length ) {
      const data = this.product.variants[0];
      this.variant[`product_${this.product.ID}`] = data.ID;
      this.sub_stock[`product_${this.product.ID}`] = data.buy_able;
      this.variantId[`product_${this.product.ID}`] = data.ID;
      this.$set(this.num, `product_${this.product.ID}`, 1);
      const obj = {
        id: this.product.ID,
        img:
          (data.feature_image && data.feature_image.thumbnail) ||
          (this.product.feature_image && this.product.feature_image.thumbnail) ||
          this.defaultImage,
        post_name: this.product.post_name,
        url: (data.feature_image && data.feature_image.url) ||
          (this.product.feature_image && this.product.feature_image.url) || ''
      }
      this.featureImageId.push(obj)
      this.price[`product_${this.product.ID}`] = Number(data.price)
      this.regular_price[`product_${this.product.ID}`] = Number(data.regular_price)
    } else {
      const obj = {
        id: this.product.ID,
        img: (this.product.feature_image && this.product.feature_image.thumbnail) || this.defaultImage,
        post_name: this.product.post_name,
        url: this.product.feature_image && this.product.feature_image.url,
      }
      this.sub_stock[`product_${this.product.ID}`] = this.product.buy_able

      this.variantId[`product_${this.product.ID}`] = this.product.ID
      this.$set(this.num, `product_${this.product.ID}`, 1)
      this.featureImageId.push(obj)
      this.price[`product_${this.product.ID}`] = Number(this.product.price)
      this.regular_price[`product_${this.product.ID}`] = Number(this.product.regular_price)
    }
    }
    if (this.group_product && this.group_product.length > 0) {
      this.group_product.forEach((item) => {
        this.title[`product_${item.ID}`] = item.post_title
        this.post_status[`product_${item.ID}`] = item.post_status == 'publish'
        let subCategories = []
        if (item.categories && item.categories.length > 0) {
          item.categories.forEach((item) => {
            subCategories.push(item.name)
          })
        }
        this.categories[`product_${item.ID}`] = subCategories

        if (item.variants && item.variants.length) {
          const data = item.variants[0]
          this.variant[`product_${item.ID}`] = data.ID
          this.sub_stock[`product_${item.ID}`] = data.buy_able
          this.price[`product_${item.ID}`] = Number(data.price)
          this.regular_price[`product_${item.ID}`] = Number(data.regular_price)
          this.variantId[`product_${item.ID}`] = data.ID
          this.$set(this.num, `product_${item.ID}`, 1)
          const obj = {
            id: item.ID,
            img:
              (data.feature_image && data.feature_image.thumbnail) ||
              (item.feature_image && item.feature_image.thumbnail) ||
              this.defaultImage,
            post_name: item.post_name,
            url: (data.feature_image && data.feature_image.url) ||
              (item.feature_image && item.feature_image.url) ||
              this.defaultImage,
          }
          this.featureImageId.push(obj)
        } else {
          const obj = {
            id: item.ID,
            img: (item.feature_image && item.feature_image.thumbnail) || this.defaultImage,
            post_name: item.post_name,
            url: (item.feature_image && item.feature_image.url) || this.defaultImage,
          }
          this.sub_stock[`product_${item.ID}`] = item.buy_able
          this.variant[`product_${item.ID}`] = item.ID
          this.price[`product_${item.ID}`] = Number(item.price)
          this.regular_price[`product_${item.ID}`] = Number(item.regular_price)
          this.variantId[`product_${item.ID}`] = item.ID
          this.$set(this.num, `product_${item.ID}`, 1)
          this.featureImageId.push(obj)
        }
      })
    }
    if (Object.keys(this.sub_stock).every((item) => this.sub_stock[item] == false)) {
      this.all_stock = true
    } else {
      this.all_stock = false
    }
  },
  components: {
    vGroupedCard,
    vInputnum,
    vImgCard,
  },
  mounted() {
    this.$el.style.setProperty('--addBtnColor', this.group_product_all.background_color)
    this.$el.style.setProperty('--addTextColor', this.group_product_all.text_color)
    //一些特殊字体会向上偏移，使title与checkbox不对齐
    const fontFamilyList = ['TenorSans-Regular','JosefinSans','NunitoSans-Regular','Roboto-Regular','Niconne-Regular','CrimsonText-Italic','Castoro-Regular','Acme-Regular','FrankRuhlLibre-Medium','DMSerifDisplay-Regular']
    const currentFontFamily = this.$('.toSub').css('font-family')
    this.inFontFamilyList =  fontFamilyList.indexOf(currentFontFamily) !== -1
  },
  watch: {
    checkedProduct: {
      handler(newV) {
        if(this.group_products_position === 'button_above') {
          let arr = [];
          this.checkedProduct.forEach(item => {
          let addproduct = { quantity: this.num[`product_${item}`] };
          addproduct.product_id = item;
          if (this.variantId[`product_${item}`] !== item) {
            addproduct.variant_id = this.variantId[`product_${item}`];
          }
          arr.push(addproduct);
          });
          let price = this.priceTotal.priceSum;
          this.$emit('checked_variants_info', arr);
          this.$emit('get_group_price', price);
        }
      },
      immediate: true,
    },
    num: {
      handler(newV) {
        if(this.group_products_position === 'button_above') {
          let arr = [];
          this.checkedProduct.forEach(item => {
          let addproduct = { quantity: this.num[`product_${item}`] };
          addproduct.product_id = item;
          if (this.variantId[`product_${item}`] !== item) {
            addproduct.variant_id = this.variantId[`product_${item}`];
          }
          arr.push(addproduct);
          });
          let price = this.priceTotal.priceSum;
          this.$emit('checked_variants_info', arr);
          this.$emit('get_group_price', price);
        }
      },
      deep: true,
    },
  },
  computed: {
    priceTotal() {
      let priceSum = 0
      let regularPriceSum = 0
      if (this.checkedProduct.length > 0) {
        let priceAll = []
        let regularPriceAll = []
        this.checkedProduct.forEach((item) => {
          let num = this.num[`product_${item}`] || 1
          priceAll.push(this.price[`product_${item}`] * num)
          regularPriceAll.push(
            this.regular_price[`product_${item}`]
              ? this.regular_price[`product_${item}`] * num
              : this.price[`product_${item}`] * num
          )
        })
        priceSum = priceAll.reduce(function (prev, cur) {
          return Number(prev) + Number(cur)
        })
        regularPriceSum = regularPriceAll.reduce(function (prev, cur) {
          return Number(prev) + Number(cur)
        })
      }
      return { priceSum, regularPriceSum }
    },
    discounts_tips() {
      let tips = {
        onOff: false,
        tips_success: '',
        tips_fail: '',
        value: 0,
        discount_type: null,
        price_tips_success: '',
      }
      let checkedProductNum = this.checkedProduct.length
      let groupNum = this.group_product.length + 1
      if (!this.group_product_price_rules || !this.group_product_price_rules.length) return false
      if (checkedProductNum == groupNum) tips.onOff = true
      tips.price_tips_success = this.$t('group.discount_tips')
      let { discount_type, value } = this.group_product_price_rules[0]
      let groupGap = groupNum - checkedProductNum
      switch (discount_type) {
        case 'percentage':
          tips.tips_fail = this.$t('group.percentage_fail', { groupNum: groupGap, value })
          tips.tips_success = this.$t('group.percentage_success', { value })
          break
        case 'flat':
          tips.tips_fail = this.$t('group.flat_fail', {
            groupNum: groupGap,
            value,
            currency: this.$store.state.options?.base?.currency_symbol,
          })
          tips.tips_success = this.$t('group.flat_success', {
            value,
            currency: this.$store.state.options?.base?.currency_symbol,
          })
          break
        case 'fixed_set_price':
          tips.tips_fail = this.$t('group.fixed_set_price_fail', { groupNum: groupGap })
          tips.tips_success = this.$t('group.fixed_set_price_success')
          break

        default:
          break
      }
      return tips
    },
  },
}
</script>
<style scoped lang='scss'>
// 组合商品
#app .product-groups {
  --addTextColor: #ffffff;
  --addBtnColor: var(--main-btn-bg);
  text-align: left;
  .groups-select {
    display: inline-block;
    .itemProduct__num {
      display: inline-flex;
      align-items: center;
      margin: 0;
      vertical-align: top;
      margin-bottom: 5px;
      @media screen and (max-width: 768px) {
        margin: 0px 0 8px;
      }
      & > span {
        margin-right: 8px;
        color: #333;
      }
      ::v-deep .product_qty {
        height: 28px;
        width: 65px;
        .subtract,
        .add {
          line-height: 20px;
        }
      }
    }
  }
  .grouped_products_card__title__discounts {
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 14px;
    line-height: 20px;
    color: #666666;
    font-weight: 500;
    text-transform: initial;
  }
  .product-groups-select {
    width: 200px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    text-align-last: center;
    height: 28px;
    line-height: 28px;
    background: #ffffff;
    border: 1px solid rgba(17, 17, 17, 0.2);
    font-size: 12px;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    padding-right: 20px;
    padding-left: 8px;
    margin: 0;
  }
  select::-ms-expand {
    display: none;
  }
  h3 {
    margin: 0;
    padding: 20px 0;
    word-wrap: break-word;
  }
  img {
    width: 100%;
    border-style: none;
    vertical-align: middle;
    border-radius: 4px;
  }

  .product-groups-info {
    &.product-groups-list {
      padding: 8px 16px 0px;
      background: #FAFBFD;
    }
    .toSub:hover {
      text-decoration: revert;
    }
    // margin-top: 20px;
    .active {
      .el-checkbox {
        opacity: 1 !important;
      }
    }

    .el-checkbox {
      color: rgba(0, 0, 0) !important;
      white-space: normal !important;
      // &::v-deep .el-checkbox__inner {
      //   background-color: var(--main-btn-bg) !important;
      //   border-color: var(--main-btn-bg) !important;
      // }
      &::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: var(--addBtnColor) !important;
        border-radius: 1px !important;
        border: 1px solid var(--addBtnColor) !important;
      }
      &::v-deep .el-checkbox__input.is-disabled .el-checkbox__inner {
        background-color: #ffffff !important;
      }
      &::v-deep .el-checkbox__inner::after {
        border: 1px solid var(--addTextColor) !important;
        border-top: 0 !important;
        border-left: 0 !important;
      }
    }

    .el-checkbox__label {
      display: inline !important;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #000 !important;
      border-color: var(--addBtnColor) !important;
      background-color: var(--addBtnColor) !important;
    }

    .el-checkbox__inner:hover {
      border-color: #000 !important;
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #000 !important;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #000 !important;
    }

    .product-groups-img {
      // width: 100px;
      // min-width: 50px;
      // height: 100px;
      // min-height: 50px;
      margin-bottom: 20px;
      overflow: hidden;
      display: flex;
      // background: #fff;
      float: left;
      img {
        width: 100px;
        // height: 100px;
        object-fit: cover;
      }
    }
    .product-groups-blow {
      width: calc((100% - 132px) / 7 + 22px) !important;
    }
    .product-groups-blow:first-child {
      width: calc((100% - 132px) / 7) !important;
    }

    .dot {
      color: #000;
      font-size: 32px;
      text-align: center;
      border-radius: 50%;
      margin: auto;
      line-height: 32px;
    }
    // .dot:last-of-type {
    //   display: none;
    // }
    // .product-groups-img::after {
    //   content: "+";
    //   line-height: 100px;
    // }
    // .product-groups-img:nth-last-child(2)::after {
    //   content: "";
    // }

    .font_family_checkbox {
      &::v-deep {
        .el-checkbox__input {
          top: 3px !important;
        }
      }
    }
    .phone_checkbox {
      &::v-deep {
        .el-checkbox__label {
          display: flex;
          flex-direction: column;
          .toSub {
            line-height: 20px !important;
            margin-bottom: 0px !important;
            padding-top: 1px !important;
          }
          .groups-select {
            margin: 6px 0 !important;
            order: 5;
          }
          .selectprice {
            line-height: 20px !important;
          }
        }
      }
    }

    .item_checkbox {
      position: relative;
      &::v-deep {
        .el-checkbox__input {
          position: absolute;
          top: 4px;
        }
        .el-checkbox__label {
          width: 100%;
          padding-left: 25px !important;
          .toSub {
            margin-bottom: 4px;
            white-space: normal;
            line-height: 20px;
            padding-top: 1px !important;
            max-width: 640px;
            word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }

  .product-groups-total {
    // min-width: 320px;
    // width: auto;
    // margin-left: 20px;
    float: left;
    min-width: 300px;
    // .dafeult_below{
    //   width: 300px !important;
    // }

    .product-groups-tips {
      background: #fff1f0;
      border: 1px solid #ffa39e;
      padding: 0.35rem 0;
      text-align: center;
      margin-bottom: 10px;

      width: 100%;
      border-radius: 3px;
    }
    &__gocart {
      width: 100%;
      color: #fff;
      background: #000;
      border: none !important;
      border-radius: 0 !important;
      line-height: 20px !important;
      display: inline-flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      &::v-deep span {
        white-space: normal;
        /* max-width: 640px; */
        line-height: normal;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
    .soldout {
      background: #f6f6f6 !important;
      color: #717171 !important;
    }
  }

  //@athena组合商品的
  .grouped_products_athena_card {
    &__product {
      display: flex;
      flex-direction: column;
    }
    .total_price {
      &__title {
        font-size: 20px;
        font-family: Roboto;
        font-weight: 500;
        color: #262626;
      }
      .selectpricewrap {
        &::v-deep .product_price_price {
          .price_text {
            font-size: 20px !important;
            font-family: Roboto !important;
            font-weight: 400 !important;
            color: #3a3a3a !important;
          }
        }
      }
    }
  }
  .grouped-product {
    &-bottom {
      margin-top: 18px;
      .gpab-price {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        font-family: Roboto;
        font-weight: 500;
        color: #262626;
        &-icon{
          white-space: nowrap;
        }
        &-num {
          text-align: right;
          & > span {
            white-space: nowrap;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .product-groups {
    .dot {
      font-size: 24px !important;
      line-height: 24px !important;
      margin: auto !important;
    }
    .groups-select {
      float: none !important;
      display: block !important;
      .product-groups-select {
        width: 170px !important;
      }
    }
    .product-groups-info {
      .groups-img {
        display: flex;
      }
      // padding: 0 15px;
      .el-checkbox {
        margin-bottom: 10px !important;
      }
      .J-ProductGroupsImg {
        .product-groups-img {
          width: calc((100vw - 400px) / 3) !important;
          // max-width: 100px;
          height: calc((100vw - 400px) / 3) !important;
          // max-height: 100px;
        }
        .product-groups-link {
          height: calc((100vw - 400px) / 3) !important;
          max-height: 100px;
        }
      }
    }
    .product-groups-total {
      min-width: 240px !important;
    }
  }
}

@media screen and (max-width: 575px) {
  #app .product-groups {
    .product-groups-info {
      .J-ProductGroupsImg {
        .product-groups-img {
          width: calc((100vw - 121px) / 3) !important;
          height: calc((100vw - 121px) / 3) !important;
        }
        .product-groups-link {
          height: calc((100vw - 121px) / 3) !important;
        }
      }
      &.product-groups-list {
        padding: 8px 8px 0px;
      }
    }
    .product-groups-total {
      width: 100% !important;
      min-width: 100% !important;
      margin-left: 0px !important;
    }

    //@athena组合商品的
    .grouped_products_athena_card {
      &__product {
        display: flex;
        flex-direction: column;
      }
      .total_price {
        margin: 25px 3px 0 3px !important;
        &__title {
          font-size: 15px !important;
          font-family: Roboto;
          font-weight: 500;
          color: #222222;
        }
        .selectpricewrap {
          &::v-deep .product_price_price {
            .price_text {
              font-size: 24px !important;
              font-family: Roboto;
              font-weight: 500;
              color: #1f2537 !important;
            }
          }
        }
      }
    }
  }
}
</style>
